import { useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const WhatIs = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      id="what"
      data-testid="what-section"
      className="relative scroll-mt-24 bg-white py-24 sm:py-36"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-end gap-10 lg:grid-cols-2">
          <Reveal>
            <span className="text-xs font-semibold uppercase tracking-[0.3em] text-brand-600">
              02 · Τι είναι
            </span>
            <h2 className="mt-6 font-display text-4xl font-bold leading-[1.05] text-ink sm:text-6xl">
              Τι είναι η VideoActive;
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="text-lg leading-relaxed text-ink/70">
              Πολύ απλά… μια νέα εποχή για το offline marketing. Είτε λανσάρεις
              νέο προϊόν, στέλνεις VIP προσκλήσεις, παρουσιάζεις την εταιρεία σου
              ή τρέχεις στοχευμένο direct mail, η VideoActive κάνει κάθε σου
              κίνηση ξεχωριστή.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.12}>
          <div
            data-testid="what-video-wrapper"
            className="group relative mt-12 aspect-video w-full overflow-hidden rounded-3xl bg-ink screen-glow"
          >
            {playing ? (
              <video
                data-testid="what-video-player"
                className="absolute inset-0 h-full w-full object-cover"
                src="/hero-video.mp4"
                controls
                autoPlay
                playsInline
              />
            ) : (
              <>
                <img
                  src="/hero-poster.jpg"
                  alt="VideoActive preview"
                  className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-ink/30" />
                <button
                  data-testid="what-video-play"
                  onClick={() => setPlaying(true)}
                  aria-label="Αναπαραγωγή βίντεο"
                  className="absolute inset-0 flex flex-col items-center justify-center gap-4"
                >
                  <span className="flex h-20 w-20 items-center justify-center rounded-full bg-brand-500 text-white shadow-2xl transition-transform duration-300 group-hover:scale-110">
                    <Play className="ml-1 h-8 w-8" fill="currentColor" />
                  </span>
                  <span className="text-sm font-semibold uppercase tracking-[0.25em] text-white/90">
                    Δες πώς λειτουργεί
                  </span>
                </button>
              </>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
